import { HandleType } from '#src/generated/graphql'

export default function handleTypeFromHandle(handle: string): HandleType {
  return handle.includes('@') ? HandleType.EMAIL : HandleType.PHONE
}
